<template>
    <div class="commonDiv" @mouseover="mouseOver = true"  @mouseleave="mouseOver = false" :class="{empty: !!!$attrs.value}" >
        <input type="text" :disabled="disabled"
            v-bind:value="$attrs.value"
            :class="inputClass"
            v-beautify.literal="vBeautify"
            v-on:input="$emit('input', $event.target.value)"
            style="padding-right: 15px;"
        />
        <i v-if="showClearBut" @click="$emit('input', $event.target.value=''),$emit('clearData')" class="clearBut">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em"><path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"></path></svg>
        </i>
    </div>

</template>

<script>

export default {
  name: "DoctuInput",
  props: {
      clearEmpty: {
          default: false,
          type: Boolean
      },
      inputClass: {
          default: '',
      },
      disabled: {
          default: false,
          type: Boolean
      },
      vBeautify: {
          default: '',
          type: String
      },
  },
  data() {
    return {
        mouseOver: false
    }
  },
  computed: {
      showClearBut() {
          return this.mouseOver && (this.$attrs.value !== '' || this.clearEmpty) && typeof this.$attrs.value !== 'undefined';
        },
  },
}
</script>

<style lang="scss">
    .commonDiv {
        display: flex;
        position: relative;
        align-items: center;
    }

    .clearBut {
        display: block;
        position: absolute;
        top: 48%;
        right: 8px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 16px;
        line-height: 1;
        color: rgba(0, 0, 0, 0.5) !important;
        vertical-align: middle;
        cursor: pointer;

        &:hover {
            color: rgba(0,0,0,.8) !important;
        }

        & svg {
            fill: currentColor;
            overflow: hidden;
        }
    }
</style>
